var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-file-input',{attrs:{"multiple":"","label":_vm.text,"truncate-length":"15"},model:{value:(_vm.file),callback:function ($$v) {_vm.file=$$v},expression:"file"}})
}
var staticRenderFns = []

export { render, staticRenderFns }